import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPlacements } from 'core/actions/ocapi';

import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

import {
  selectMarketingBannerMobileConfig, selectMarketingBannerMobileIsLoaded,
  selectMarketingBannerMobileIsLoading, selectMarketingBannerMobilePlacements,
  selectMarketingBannerDesktopConfig, selectMarketingBannerDesktopIsLoaded,
  selectMarketingBannerDesktopIsLoading, selectMarketingBannerDesktopPlacements,
} from '../selectors';

import config from '../configs';

export const useGetMarketingBanner = () => {
  const dispatch = useDispatch();

  const mobileBannerConfig = useSelector(selectMarketingBannerMobileConfig);
  const mobileBannerIsLoaded = useSelector(selectMarketingBannerMobileIsLoaded);
  const mobileBannerIsLoading = useSelector(selectMarketingBannerMobileIsLoading);
  const mobileBannerPlacements = useSelector(selectMarketingBannerMobilePlacements);

  const desktopBannerConfig = useSelector(selectMarketingBannerDesktopConfig);
  const desktopBannerIsLoaded = useSelector(selectMarketingBannerDesktopIsLoaded);
  const desktopBannerIsLoading = useSelector(selectMarketingBannerDesktopIsLoading);
  const desktopBannerPlacements = useSelector(selectMarketingBannerDesktopPlacements);

  const isMobileMQ = useSelector(selectIsMobileMQ);

  const { shouldUseOnlyMobileBanner, shouldUseOnlyDesktopBanner } = config;

  const getMobileBanner = () => {
    if (!mobileBannerIsLoaded && !mobileBannerIsLoading) {
      const { api: { params, options } = {} } = mobileBannerConfig;
      dispatch(fetchPlacements(params, options));
    }
  };

  const getDesktopBanner = () => {
    if (!desktopBannerIsLoaded && !desktopBannerIsLoading) {
      const { api: { params, options } = {} } = desktopBannerConfig;
      dispatch(fetchPlacements(params, options));
    }
  };

  /*
  VHP: On mobile screen sizes we display mobile version of the banner, on desktop - desktop version of the banner.
  If no image is returned from mobile content group we display desktop banner on mobile as well;
  Acq: We display only desktop version of the banner;
  Sweeps: We display only mobile version of the banners (2 items);
  */
  useEffect(() => {
    if (shouldUseOnlyMobileBanner) {
      getMobileBanner();
      return;
    }

    if (shouldUseOnlyDesktopBanner) {
      getDesktopBanner();
      return;
    }

    if (isMobileMQ) {
      getMobileBanner();
    }

    if (!isMobileMQ || (mobileBannerIsLoaded && isEmpty(mobileBannerPlacements))) {
      getDesktopBanner();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobileMQ, mobileBannerIsLoaded, mobileBannerPlacements]);

  const chooseBannerToShow = () => {
    const mobileBanner = {
      bannerPlacementsToShow: mobileBannerPlacements,
      config: mobileBannerConfig,
    };

    const desktopBanner = {
      bannerPlacementsToShow: desktopBannerPlacements,
      config: desktopBannerConfig,
    };

    if (shouldUseOnlyMobileBanner) {
      return mobileBanner;
    }

    if (shouldUseOnlyDesktopBanner) {
      return desktopBanner;
    }

    if (isMobileMQ && mobileBannerIsLoaded && !isEmpty(mobileBannerPlacements)) {
      return mobileBanner;
    }

    return desktopBanner;
  };

  const bannerToShow = chooseBannerToShow();

  return bannerToShow;
};
